import {
  IApiRequest,
  IApiResponse,
  IWorkOrder,
  IWorkOrderListResponse,
} from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_WORK_ORDERS = `${TASK_SERVICE}/work-orders`;

export const workOrders = {
  getAll: async ({ filters, sort, top, skip }: IApiRequest = {}): Promise<
    IApiResponse<IWorkOrderListResponse[]>
  > => {
    const options = await apiOptions({
      filters,
      sort,
      top,
      skip,
      url: API_WORK_ORDERS,
    });

    return apiRequest(options);
  },
  getById: async ({
    id,
  }: {
    id: string;
  }): Promise<IApiResponse<IWorkOrder>> => {
    const options = await apiOptions({
      url: `${API_WORK_ORDERS}/${id}`,
    });

    return apiRequest(options);
  },
  hold: async ({ id, data, modifiedOn, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDERS}/${id}/hold`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION, "if-match": modifiedOn },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  release: async ({
    id,
    data,
    modifiedOn,
    toastMessageConfig,
  }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_WORK_ORDERS}/${id}/release`,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "put",
      data,
      modifiedOn,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
